import classNames from "classnames"
import s from '../../index.module.css';
import classes from './index.module.css';
import Button from "@UI/New/Button";
import { useDispatch } from "react-redux";
import { useAddAlert } from "@/hooks/useAddAlert";
import { closeAllModal } from "@store/modalsSlise";
import { useState } from "react";
import { CourseSelection } from "./components/CourseSelection";
import { SeminarianSelection } from "./components/SeminarianSelection";
import { GroupSelection } from "./components/GroupSelection";
import { NumberOfLessons } from "./components/NumberOfLessons";
import { timetableBeta } from "@/api";

const AddingToPlanningTable = ({data}) => {
    const [loading, setLoading] = useState(false);
    const addAlert = useAddAlert();
    const dispatch = useDispatch();
    const initState = {
        direction_id: null,
        teacher_id: null,
        number_of_lessons: 0,
        group_id: null,
        child_id: null,
    };
    const [state, setState] = useState(initState)
    const setFieldInState = ({field, value, resetFields=[]}) => {
        setState((prevState) => (
            {
                ...prevState,
                [field]: value,
                ...resetFields.reduce((acc, key) => {
                    acc[key] = initState[key];
                    return acc;
                }, {})
            }
        ))
    }

    const add = () => {
        if(!state.direction_id || !state.teacher_id || !state.group_id || typeof state.number_of_lessons === 'string') {
            addAlert({type:'error', title: 'Ошибка', text: 'Заполните все поля'})
            return;
        }
        setLoading(true)
        timetableBeta.createPlan({...state})
            .then(({data}) => {
                if(data.status === 'success'){
                    data.getData();
                    addAlert({ title: 'Успешно добавлено' })
                    dispatch(closeAllModal())
                }
            })
            .finally(() => setLoading(false))
    }

    return (
        <div className={classNames(s.modalContainer, classes.modalContainer)}>
            <div className={s.modalHeader}>
            <div className={s.modalTitleContainer}>
                <span className={s.modalHeaderBigTitle}>
                    Добавить
                </span>
            </div>
            </div>
            <div className={classNames(s.contentWrapper, classes.contentWrapper)}>
               <CourseSelection {...{state, setFieldInState}} />
               <SeminarianSelection {...{state, setFieldInState}} />
               <GroupSelection {...{state, setFieldInState}} />
               <NumberOfLessons {...{state, setFieldInState}} />
               <Button 
                    disabled={loading}
                    onClick={add}
                    className={classes.button}>
                    Добавить
               </Button>
            </div>
        </div>
    )
}
export default AddingToPlanningTable;